<i18n lang="yaml">
zh:
  tab_messages: "消息"
  tab_announcements: "公告"
  btn_mark_read: "标记为已读"
  btn_delete: "删除"
  table_title: "标题"
  tag_unread: "未读"
  table_time: "时间"
  table_detail: "详情"
  input_placeholder: "请输入内容"
  msg_delete_success: "删除成功"
  msg_mark_read_success: "标记为已读成功"
  dialog_delete_confirm: "确定删除吗?"
  dialog_title: "提示"
  dialog_confirm: "确定"
  dialog_cancel: "取消"
en:
  tab_messages: "Messages"
  tab_announcements: "Announcements"
  btn_mark_read: "Mark as Read"
  btn_delete: "Delete"
  table_title: "Title"
  tag_unread: "Unread"
  table_time: "Time"
  table_detail: "Detail"
  input_placeholder: "Please enter content"
  msg_delete_success: "Deleted successfully"
  msg_mark_read_success: "Marked as read successfully"
  dialog_delete_confirm: "Are you sure to delete?"
  dialog_title: "Notice"
  dialog_confirm: "Confirm"
  dialog_cancel: "Cancel"
</i18n>
<template>
<div style="padding: 1rem 1rem;background: #FAFAFD;position: relative;transform: translate(0);">
  <div style="font-weight: 400;color: rgba(0,0,0,0.8);position: relative;" class="d-flex flex-y-center flex-between">
    <div style="width: 20px; height: 20px; background-image: radial-gradient(20px at top left,transparent 20px,#fff 20px); position: absolute; left: 20px; top: 25px;" />
      <div class="d-flex flex-y-center pointer" style="padding: 0.3rem 0.3rem 0 0; display: flex; gap: 10px; align-items: center;" >
        <img src="@/assets/icon-home.png" width="30" height="30" alt="" @click="goHome()">
        <el-tabs type="card" v-model="activeTab" @tab-click="handleTabClick">
          <el-tab-pane :label="$t('tab_announcements')" name="announcements">
            <div slot="label" style="display: flex; gap: 10px; align-items: center;justify-content: center; position: relative;">
              <span>{{ $t('tab_announcements') }}</span>
              <span v-if="announcementsCount" style="position: absolute; top: 0; right: 0px; background: #FF2424;color: white;border-radius: 10px;padding: 0 5px;font-size: 12px; line-height: 16px; z-index: 100;">{{ announcementsCount }}</span>
            </div>
          </el-tab-pane>
          <el-tab-pane :label="$t('tab_messages')" name="messages" style="position: relative;">
            <div slot="label" style="display: flex; gap: 10px;justify-content: center; align-items: center; position: relative;">
              <span>{{ $t('tab_messages') }}</span>
              <span v-if="unreadCount && unreadCount !== '0'" style="position: absolute; top: 0; right: -20px; background: #FF2424;color: white;border-radius: 10px;padding: 0 5px;font-size: 12px; line-height: 16px; z-index: 100;">{{ unreadCount }}</span>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>

      <div class="hidden-xs-only" style="display: flex;gap: 10px;" v-if="activeTab === 'messages'">
        <el-button class="button" type="primary" size="small" :disabled="!selections.length" @click="onBatchRead()">{{$t('btn_mark_read')}}</el-button>
        <el-button class="button" icon="el-icon-delete" type="primary" size="small" :disabled="!selections.length" @click="onBatchRemove">{{$t('btn_delete')}}</el-button>
        <!-- <div
          class="remove-button d-flex flex-y-center pointer" :disabled="!selections.length" @click="onBatchRemove"
          style="background: #DBE5FD; border-radius: 20px;font-size: 14px;color: #0052D9;padding: 5px 10px;">
          <img src="@/assets/notify-delete.png" width="16" height="16" alt="">
          <span style="">删除</span>
        </div> -->
      </div>
  </div>


  <!-- 数据表格 -->
  <el-table
    :row-style="{height:'40px', lineHeight: '40px', cursor: 'pointer'}"
    :cell-style="{padding:'14px 0px', borderTop: '1px solid #f8f8f8'}"
    :header-cell-style="{color:'rgba(0,0,0,0.4)','font-weight': 400, 'font-size': '14px', padding: '0 16px'}"
    :data="tableData"
    :highlight-current-row="false"
    ref="tableContainer"
    class="table-container"
    @row-click="handleRowClick"
    @selection-change="onSelectionChange"
    >
    <el-table-column v-if="activeTab === 'messages'"
      type="selection"
      width="55">
    </el-table-column>

    <el-table-column align="left"
      prop="title"
      :label="$t('table_title')"
      show-overflow-tooltip
      min-width="180px"
    >
      <template slot-scope="scope">
        <span v-html="scope.row.title || scope.row.predLabel"></span>
        <span v-if="!scope.row.readFlag" style="color: #D54941;background: #FFF0ED;border-radius: 3px 3px 3px 3px;border: 1px solid #D54941;padding: 3px;font-size: 12px;margin-left: 10px;">{{$t('tag_unread')}}</span>
      </template>
    </el-table-column>

    <el-table-column align="left"
      prop="startTime"
      :label="$t('table_time')"
      min-width="120px"
    >
      <template slot-scope="scope">
        <span style="color: rgba(0, 0, 0, 0.40); font-size: 14px;">{{ scope.row.startTime || scope.row.createTime }}</span>
      </template>
    </el-table-column>

    <el-table-column align="left"
      prop="content"
      :label="$t('table_detail')"
      min-width="300px"
      show-overflow-tooltip>
      <template slot-scope="scope">
        <div class="single-line-content" v-if="activeTab === 'messages'">{{scope.row.content}}</div>
        <div class="single-line-content" v-else>{{scope.row.remark}}</div>
      </template>
    </el-table-column>
  </el-table>

  <el-row class="pagination-fixed"  v-if="token != ''">
    <el-col>
      <div class="pagination">
        <el-pagination background
          hide-on-single-page
          :page-sizes="paginations.pages"
          :page-size="paginations.size"
          :layout="paginations.layout"
          :total="paginations.total"
          :current-page.sync="paginations.current"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
    </el-col>
  </el-row>

  <div class="hidden-sm-and-up" style="display: flex;gap: 10px;z-index: 1000;width: 100%;background: #FAFAFD;align-items: center;justify-content: center;" v-if="activeTab === 'messages'">
      <br><br>
      <el-button class="button" type="primary" size="small" :disabled="!selections.length" @click="onBatchRead()">{{$t('btn_mark_read')}}</el-button>
      <el-button class="button" icon="el-icon-delete" type="primary" size="small" :disabled="!selections.length" @click="onBatchRemove">{{$t('btn_delete')}}</el-button>
    </div>
</div>
</template>
<script>
import * as EnumApi from '@/api/enums'
import * as ArticleApi from '@/api/article'
import { mapState, mapMutations} from 'vuex'
import request from '@/utils/request'
import * as ImMessageApi from '@/api/immessage'

export default {
  name: 'NotifyList',
  components: {

  },
  data() {
    return {
      activeTab: 'announcements',
      unreadCount: 0,
      announcementsCount: 0,
      selections: [],
      tableWidth: 0,
      sliderBoxActive: 0,
      showUpdateFlag: false,
      fromType: 'writer_client',
      enums: {},
      intervalId: null,
      uploadFile: {},
    	targetPermit: 'article',
      queryForm: {
        fromType: 'writer-web-notify-all',
        articleGroup: 'MESSAGE',
        current: '',
        size: 20
      },
      rules: {
        name: [
          { required: true, message: this.$t('input_placeholder'), trigger: 'blur' }
        ]
      },
      tableData: [],
      progressMap: new Map(),
      activeMenuItem: 1,
      paginations: {
        current: 1, // 当前页
        total: 0, // 总行数
        size: 20, // 每页行数
        // sizes: [20], // 每页行数 调整
        layout: 'total, prev, pager, next' // 翻页属性
      }
    }
  },
  async mounted() {
    this.$nextTick(() => {
      this.tableWidth = this.$refs.tableContainer.$el.offsetWidth;
      console.log('tableWidth', this.tableWidth);
    })
    this.unreadCount = await this.fetchUnreadCount()
    this.handlePage()
    this.$eventHub.$emit('refreshUnreadCount', this.unreadCount)
  },
  computed: {
  	...mapState(['user', 'currentNotifyId', 'token'])
  },
  beforeDestroy() {
  },
  methods: {
    async fetchUnreadCount() {
      const { data } = await ImMessageApi.getStat([this.user.id])
      this.unreadCount = data.data.unread || 0
      return this.unreadCount
    },
    handleTabClick(tab, event) {
      this.queryForm.current = 1
      this.queryForm.size = 20
      // this.tableData = []
      this.handlePage()
    },
    async onBatchRead() {
      const ids = this.selections.map(item => item.id)
      if (!ids.length) return
      await request({
        url: '/auth-service/im_messages/batch_read',
        method: 'post',
        data: { ids }
      })
      this.$message.success(this.$t('msg_mark_read_success'))
      this.unreadCount = await this.fetchUnreadCount()
      this.$eventHub.$emit('refreshUnreadCount', this.unreadCount)
      this.handlePage()
    },
    async onBatchRemove() {
      const ids = this.selections.map(item => item.id)
      if (!ids.length) return
      await request({
        url: '/auth-service/im_messages/batch_remove',
        method: 'post',
        data: { ids }
      })
      this.$message.success(this.$t('msg_delete_success'))
      this.unreadCount = await this.fetchUnreadCount()
      this.$eventHub.$emit('refreshUnreadCount', this.unreadCount)
      this.handlePage()
    },
    onSelectionChange(val) {
      this.selections = val
    },
    ...mapMutations(['setCurrentNotifyId', 'setActiveMenuItem']),
    async handleRowClick(row, column, event) {
      if (this.activeTab === 'announcements') {
        this.setCurrentNotifyId(row.id)
        this.$router.push(`/newsdetail/${row.id}`)
        return
      }

      await request({
        url: '/auth-service/im_messages/batch_read',
        method: 'post',
        data: { ids: [row.id] }
      })
      window.submission_query_id = row.storyId
      this.$router.push(`/account/submissions`)
    },
    handleRemove(item) {
      this.$confirm(this.$t('dialog_delete_confirm'),this.$t('dialog_title'), {
        confirmButtonText: this.$t('dialog_confirm'),
        cancelButtonText: this.$t('dialog_cancel'),
        customClass: 'custom-confirm',
        center: false
      }).then(() => {
        FileApi.remove(item.id).then(res => {
          this.handlePage();
        });
      }).catch((e) => {console.log('error', e)});
    },
    goHome(){
      this.setActiveMenuItem('1')
      if(this.token == ''){
        this.$router.push('/')
      }else{
        this.$router.push('/home')
      }
    },
    handleSelectionChange(val) {
      console.log('select change',val);
      this.multipleSelection = val;
    },
    /**
     * 将数组中指定id的元素移动到首位
     * @param {Array} arr - 原始数组
     * @param {string|number} id - 要移动到首位的元素的id
     * @returns {Array} - 处理后的新数组
     */
    moveItemToFirst(arr, id) {
      // 1. 使用 findIndex 找到目标元素的索引
      const index = arr.findIndex(item => item.id === id);

      // 2. 如果找不到该元素，直接返回原数组
      if (index === -1) return [...arr];

      // 3. 创建新数组（避免修改原数组）
      const newArr = [...arr];

      // 4. 使用 splice 移除目标元素，并插入到首位
      const [targetItem] = newArr.splice(index, 1);
      newArr.unshift(targetItem);

      return newArr;
    },
    async fetchMessages() {
      if (!this.token){
        this.tableData = []
         return false
      }
      this.queryForm.current = this.paginations.current
      this.queryForm.size = this.paginations.size
      const res = await request({
        url: `/auth-service/im_messages/page?toUserId=${this.user.id}`,
        method: 'get',
        params: {
          ...this.queryForm
        }
      })

      const result = res.data.data
      this.tableData = result.records
      this.paginations.total = Number(result.total)
      this.paginations.current = Number(result.current)
      this.paginations.size = Number(result.size)
      this.messagesCount = Number(result.total)
    },
    async fetchAnnouncements() {
      const res = await ArticleApi.page(this.queryForm)
      this.queryForm.current = this.paginations.current
      this.queryForm.size = this.paginations.size

      const result = res.data.data
      this.tableData = result.records
      this.paginations.total = Number(result.total)
      this.paginations.current = Number(result.current)
      this.paginations.size = Number(result.size)
    },
    async fetchAnnouncementsCount() {
      const res = await ArticleApi.page(this.queryForm)
      const result = res.data.data
      this.announcementsCount = Number(result.total)
    },
    handlePage(current) {
      if (this.activeTab === 'messages') {
        this.fetchMessages()
      } else {
        this.fetchAnnouncements()
      }
      // let that = this;
      // if (current) {
      //   that.paginations.current = current
      // }
      // that.queryForm.current = that.paginations.current
      // that.queryForm.size = that.paginations.size

      // // 获取表格数据
      // ArticleApi.page(that.queryForm).then(res => {
      //   let result = res.data.data;
      //   // that.tableData = that.moveItemToFirst(result.records, this.currentNotifyId)
      //   that.tableData = result.records

      //   that.paginations.total = Number(result.total)
      //   that.paginations.current = Number(result.current)
      //   that.paginations.size = Number(result.size)
      // })
    },
    handleCurrentChange(page) {
      // 切换页码
      this.paginations.current = page
      this.handlePage()
    },
    handleSizeChange(size) {
      // 切换size
      this.paginations.size = size
      this.size = size
      this.handlePage()
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep .el-tooltip__popper {
  max-width: 200px;
}
.pagination-fixed {
  position: fixed;
  bottom: 0;
  right: 0;
  margin-bottom: -2rem;
  margin-right: 8px;
  background: #FAFAFD;
  padding: 1rem 0;
}
.custom-select {
    /deep/ .el-input__inner {
      border-radius: 20px;
      height: 1.5rem;
      line-height: 1.5rem;
    }
    /deep/ .el-input__suffix {
      height: 1.5rem;
      line-height: 1.5rem;
      font-size: 12px;
      display: flex;
      align-items: center;
    }
}
/* 取消行悬停效果 */
// /deep/ .el-table--enable-row-hover {
//     background-color: transparent !important;
// }

/* 取消行过渡效果 */
/deep/ .el-table--enable-row-transition {
    transition: none !important;
}
/deep/ .el-table th.el-table__cell.is-leaf, /deep/ .el-table td.el-table__cell {
  border-bottom: none;
}
.table-container {
  margin-bottom: 1rem;
  /deep/ .el-table__body {
    // border-spacing: 0 10px;
    border-radius: 20px;
    width: auto !important;
  }
  /deep/ .el-table__body-wrapper.is-scrolling-left{
    width: auto !important;
  }
  /deep/ .el-table__body-wrapper .el-table__empty-block {
    width: auto !important;
  }
}

::v-deep .el-table td:first-child {
  // border-radius: 20px 0 0 20px;
  padding-left: 2rem;
}
::v-deep .el-table td:last-child {
  // border-radius: 0 20px 20px 0;
}

::v-deep td.el-table__cell {
  color: rgba(0,0,0,0.8);
  // background-color: transparent !important;
}
::v-deep .el-table .el-table__cell:first-child {
  font-weight: bold;
  padding-left: 2rem;
}
::v-deep .el-table__row:hover{
  background-color: #E5E7FC !important;
}
::v-deep .el-table__row {
  font-weight: 400;
  font-size: 14px;
  color: rgba(0,0,0,0.8);
}
.max-width-column .cell {
  max-width: 15rem; /* 设置最大宽度 */
  white-space: nowrap; /* 防止文本换行 */
  overflow: hidden; /* 隐藏超出部分 */
  text-overflow: ellipsis; /* 显示省略号 */
}

.data-empty {
  padding: 1rem;
  height: calc( 100vh - 8rem );
}
/deep/ .el-empty {

}
/deep/ .el-empty__bottom {
  margin-top: 10px;
}
/deep/ .el-table__empty-text {
  line-height: 0px !important;
}
.search-title {
  /deep/ .el-input__inner {
    height: 1.5rem;
    line-height: 1.5rem;
    font-size: 12px;
  }
  /deep/ .el-input__suffix {
    height: 1.5rem;
    line-height: 1.5rem;
    font-size: 12px;
    display: flex;
    align-items: center;
  }
}
/* CSS样式 */
.image-switcher {
  display: inline-block;
  width: 14px;
  height: 14px;
  background-size: cover;
  transition: background-image 0.3s; /* 平滑过渡效果 */
  &-sousuo-hui {
    background-image: url('../../assets/icon-sousuo.png'); /* 默认状态下的图片 */
  }
  &-sousuo {
    background-image: url('../../assets/icon-sousuo.png'); /* 默认状态下的图片 */
  }
  &-sousuo:hover {
    background-image: url('../../assets/icon-sousuo-1.png'); /* 默认状态下的图片 */
  }
  &-sousuo:active {
    background-image: url('../../assets/icon-sousuo.png'); /* 默认状态下的图片 */
  }

  &-edit {
    background-image: url('../../assets/icon-edit.png'); /* 默认状态下的图片 */
  }
  &-edit:hover {
    background-image: url('../../assets/icon-edit-1.png'); /* 默认状态下的图片 */
  }
  &-edit:active {
    background-image: url('../../assets/icon-edit.png'); /* 默认状态下的图片 */
  }

  &-chaishu {
    background-image: url('../../assets/icon-chaishu.png'); /* 默认状态下的图片 */
  }
  &-chaishu:hover {
    background-image: url('../../assets/icon-chaishu-1.png'); /* 默认状态下的图片 */
  }
  &-chaishu:active {
    background-image: url('../../assets/icon-chaishu.png'); /* 默认状态下的图片 */
  }

  &-delete {
    background-image: url('../../assets/icon-delete.png'); /* 默认状态下的图片 */
  }
  &-delete:hover {
    background-image: url('../../assets/icon-delete-1.png'); /* 默认状态下的图片 */
  }
  &-delete:active {
    background-image: url('../../assets/icon-delete.png'); /* 默认状态下的图片 */
  }
}
.single-line-content {
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  word-break: break-all;
}

.el-table {
  background: white;
  // border-radius: 15px;
}

.button {
  background: rgba(219, 229, 253, 1);
  color: rgba(0, 82, 217, 1);
  border: 0;
}
.button[disabled] {
  background: rgba(206, 208, 218, 0.19);
  color: rgba(0, 0, 0, 0.26);
  opacity: 0.8;
  &:hover {
    background: rgba(206, 208, 218, 0.19);
    color: rgba(0, 0, 0, 0.26);
    cursor: not-allowed;
  }
}
.button:hover {
  background: rgba(54, 110, 244, 1);
  color: white;
}

::v-deep .el-tabs__header {
  margin-bottom: 0;
  border-bottom: none!important;
}
::v-deep .el-tabs__nav {
  border: 0!important;
}
::v-deep .el-tabs__item {
  padding: 0 40px;
  border: 0!important;
  border-radius: 1rem 1rem 0 0;
  background: rgba(231, 238, 254, 1);
  color: black!important;
  width: 120px;
  text-align: center;
}
::v-deep .el-tabs__item.is-active {
  border: 0!important;
  background: white;
  font-weight: bold;
}
::v-deep .el-table {
  border-radius: 1rem;
  overflow: hidden;
}
::v-deep .el-table .has-gutter  {
  padding-left: 10px;
  height: 40px;
  line-height: 40px;
}

::v-deep .el-table__header-wrapper th.el-table__cell > .cell,
::v-deep .el-table__row .el-table__cell > .cell {
  padding: 0!important;
}

::v-deep .el-table {
  // padding: 0 16px!important;
  &::before {
    height: 0!important;
  }
  th, td {
    padding: 0!important;
    box-sizing: content-box!important;
  }

  .el-table__header .el-table__cell .cell,
  .el-table__row .el-table__cell .cell {
    padding-left: 16px!important;
    padding-right: 16px!important;
  }
}

</style>
